import type { Song } from '../types';
import { CensoredLyrics } from './CensoredLyrics';

const GENRE_EMOJI: Record<string, string> = {
  'Hip-Hop': '🎤',
  'R&B': '🎷',
  'Gospel': '⛪',
  'Pop': '✨',
  'Rap': '🎙',
  'Soul': '🎺',
  'Other': '🎵',
};

export function SongCard({
  song,
  children,
}: {
  song: Song;
  children?: React.ReactNode;
}) {
  return (
    <div className="song-card">
      <div
        className="song-art"
        style={{
          background: `linear-gradient(135deg, ${song.coverColor}, #090909)`,
        }}
      >
        {GENRE_EMOJI[song.genre] ?? '🎵'}
      </div>
      <div className="song-body">
        <div className="flex-between gap-8">
          <div className="song-title">{song.title}</div>
          <span className="muted" style={{ fontSize: 12 }}>
            {song.durationLabel}
          </span>
        </div>
        <div className="song-meta">
          {song.genre} · by {song.ownerUsername} · {song.plays} plays
        </div>
        <div className="flex gap-8 wrap mt-16" style={{ marginTop: 10 }}>
          {song.privacy === 'PRIVATE' && (
            <span className="chip chip-private">Private</span>
          )}
          {song.privacy === 'PUBLIC_REQUESTED' && (
            <span className="chip chip-requested">Pending Review</span>
          )}
          {song.privacy === 'PUBLIC_APPROVED' && (
            <span className="chip chip-approved">On The Wave</span>
          )}
          {song.contentRating === 'CLEAN' ? (
            <span className="chip chip-clean">Clean</span>
          ) : (
            <span className="chip chip-explicit">Explicit</span>
          )}
          {song.parentalAdvisory && (
            <span
              className="parental-advisory"
              title="Parental Advisory — Explicit Content. Profanity is censored with [BEEP] on The Wave, like TV or radio."
            >
              ⚠ Parental Advisory
            </span>
          )}
        </div>
        {song.censoredOnWave && song.lyrics && (
          <CensoredLyrics text={song.lyrics} />
        )}
        {children && <div className="song-actions">{children}</div>}
      </div>
    </div>
  );
}
